module.exports = __webpack_public_path__ + "img/candidates.ab6448f7.svg";